import { Box, BoxProps, Divider } from '@chakra-ui/react';
import React from 'react';
import ContentTitle from './ContentTitle';

type ContentBlockProps = BoxProps & {
    title?: String;
    noDivider?: boolean;
    ActionComponent?: JSX.Element;
};

const ContentBlock: React.FC<ContentBlockProps> = ({
    title,
    noDivider = false,
    ActionComponent,
    children,
    ...rest
}) => {
    return (
        <Box {...rest}>
            {!noDivider && <Divider marginY="8" />}
            {title && (
                <ContentTitle title={title} ActionComponent={ActionComponent} />
            )}

            <Box marginTop={4}>{children}</Box>
        </Box>
    );
};

export default ContentBlock;
